module.exports = __webpack_public_path__ + "img/slide3.8d0eaecd.jpg";